import { render, staticRenderFns } from "./loginLoading.vue?vue&type=template&id=528c73b4&scoped=true&"
import script from "./loginLoading.vue?vue&type=script&lang=js&"
export * from "./loginLoading.vue?vue&type=script&lang=js&"
import style0 from "./loginLoading.vue?vue&type=style&index=0&id=528c73b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c73b4",
  null
  
)

export default component.exports